import { useTranslation } from "react-i18next";
import { getThemeColors } from "../lib/theme";

interface FullscreenButtonProps {
  isDark: boolean;
  isFullscreen: boolean;
  onClick: () => void;
  showLabel?: boolean;
  testId: string;
}

export function FullscreenButton({
  isDark,
  isFullscreen,
  onClick,
  showLabel = true,
  testId,
}: FullscreenButtonProps) {
  const { t } = useTranslation();
  const theme = getThemeColors(isDark);
  const label = isFullscreen
    ? t("components.fullscreen.exit")
    : t("components.fullscreen.enter");

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      aria-pressed={isFullscreen}
      title={label}
      data-testid={testId}
      className={`${theme.buttonSmall} ${showLabel ? "" : "px-1.5!"}`}
    >
      {isFullscreen ? <MinimizeIcon /> : <MaximizeIcon />}
      {showLabel ? <span>{label}</span> : null}
    </button>
  );
}

function MaximizeIcon() {
  return (
    <svg
      aria-hidden="true"
      className="h-4 w-4"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M8 3H3v5m13-5h5v5M8 21H3v-5m18 0v5h-5"
      />
    </svg>
  );
}

function MinimizeIcon() {
  return (
    <svg
      aria-hidden="true"
      className="h-4 w-4"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M8 3v5H3m13-5v5h5M8 21v-5H3m13 5v-5h5"
      />
    </svg>
  );
}
